import React, { useCallback } from 'react';

import { getCallbackUrl } from '@futrli/organisations';
import { useSyncContext } from '../../../../../core/sync-context/sync-context';
import { useIsExcelOrganisation } from '../../../../../predict-management/hooks/useIsExcelOrganisation';
import { SyncControlContainerContent } from './sync-control-container-content';
import { SyncControlVariant } from './types';

interface SyncControlContainerProps {
  errorMessage?: React.ReactNode;
  syncingMessage?: React.ReactNode;
  showSyncNowLabel?: boolean;
  unreconciledTransactionsCount?: number | null;
  variant: SyncControlVariant;
}

export const SyncControlContainer = ({
  errorMessage,
  syncingMessage,
  showSyncNowLabel,
  unreconciledTransactionsCount,
  variant
}: SyncControlContainerProps) => {
  const isExcelOrganisation = useIsExcelOrganisation();

  const {
    syncControlState,
    workspaceId,
    organisation,
    datasource,
    datasourceState,
    syncTimestamp,
    reconnect,
    handleOauth2SyncNow,
    integration,
    needsReconnect
  } = useSyncContext();

  const handleReconnect = useCallback(
    () => reconnect(getCallbackUrl(window.location.href)),
    [reconnect]
  );

  return (
    <SyncControlContainerContent
      syncControlState={syncControlState}
      workspaceId={workspaceId}
      organisation={organisation}
      datasource={datasource}
      isExcelOrganisation={isExcelOrganisation}
      datasourceState={datasourceState}
      errorMessage={errorMessage}
      syncingMessage={syncingMessage}
      showSyncNowLabel={showSyncNowLabel}
      syncTimestamp={syncTimestamp}
      reconnect={handleReconnect}
      handleOauth2SyncNow={handleOauth2SyncNow}
      integration={integration}
      unreconciledTransactionsCount={unreconciledTransactionsCount}
      variant={variant}
      needsReconnect={needsReconnect}
    />
  );
};
